module["exports"] = [
  "Постач",
  "Торг",
  "Пром",
  "Трейд",
  "Збут"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/uk/company/suffix.js
// module id = 2381
// module chunks = 0